<template>
   <div class="accordion" role="tablist">

                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                  
                         <b-button block v-b-toggle.accordion-20 variant="outline-primary">First Steps</b-button>
                   
                    </b-card-header>
                    <b-collapse id="accordion-20" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <ul>
                          <li>Click on the Get Started button above, to create an account.</li>
                     
                          <li>Fill in the registration form.</li>
                          <li>Go to the systems menu option -> organisation, and fill in the rest of your organisation information and update your logo.</li>
                          <li>Then create a scheme, explained next.</li>
                               <li class="text-danger">If you joining an existing organisation, request an admin to give you access via the system, do not register.</li>
                        </ul>
                       
                      </b-card-body>
                    </b-collapse>
                  </b-card>


                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                    
                         <b-button block v-b-toggle.accordion-1 variant="outline-primary">Schemes</b-button>
                    
                    </b-card-header>
                    <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                      A scheme is the reason for the collection. For example, a scheme could be 'New Carpet Funds' or 'Masjid Upkeep' or '2022 Madressah Fees - Grade 4'. <br><br>
              
               A scheme requires plans. a plan specifies the frequency and amount to collect from the contributors, and a scheme can have multiple plans. Ad Hoc plans are also supported, ad hoc meaning contributors will pay varying amounts at any frequency. For Monthly and Annual plans, the contribution are automatically generated, and with a single click you may confirm if the contribution for that period was collected or not.
               <br><br>

                Ad Hoc plans, are for contributors who pay varying amounts at no fixed frequency.
                For example a collection scheme for a new building, where donations are given by 'contributors' . 
                <br><br>
                If 'collectors linked to contributors' option is ticked on a scheme, then the specified system users(collectors) can only collect funds from their allocated contributors. (Explained further below under contributors)
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-2 variant="outline-primary">Scheme Plans</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        Every scheme will have a set of collection plans. For example, if the collection is for a project and its an optional contribution , then you will create an Ad Hoc collection plan. So contributors allocated to this plan, can pay any amount at any time .
                        <br><br>
                         If you create a Monthly or Annual plan, then the system auto generates the contribution (Outstanding Contributions menu option) either every month or once for the year, and then the collector or administrator will mark off when they receive the funds and how much.
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-3 variant="outline-primary">Contributors</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        Contributors are the people who contribute to the scheme (Donors/Students/Funders), and will have to be allocated to a scheme plan. For example if its Madressah fees, then the student will be the contributor.
                        <br><br>
                        They can be allocated to a collector. this is useful in a scenario where a collector (system user), is in charge of collecting funds from a set group of contributors, for example every month. The use of collectors is completely optional. 
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                   <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-4 variant="outline-primary">Collectors / Users</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        A collector is simply a user created in the users menu, and given a role with ability to do collections. 
                        (Roles are a collection of system menu options, which specify what actions a user can perform in the system).

                        <br><br>
                        Collectors are then optionally allocated to contributors. The use of collectors are optional and are there to help where individuals are responsible to collect funds from a set of allocated contributors on a monthly or annual basis.
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                   <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-5 variant="outline-primary">Outstanding Contributions</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        The outstanding contributions is the list of auto generated  (Monthly / Annual Scheme Plans) where the funds have not been received as yet, and they will need to be marked as received or not collected. 
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                   <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-6 variant="outline-primary">Processed Contributions</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        This is a list of funds that have been collected or not for the scheme, with the option of reversing a transaction.
                      </b-card-body>
                    </b-collapse>
                  </b-card>


                   <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-8 variant="outline-primary">Scheme Debits</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        When funds are removed from the scheme, you will note those transactions under this menu, thus allowing you to have an accurate running total of the scheme's fund.
                      </b-card-body>
                    </b-collapse>
                  </b-card>


                </div>
</template>

<script>
export default {

}
</script>

<style>

</style>